import * as React from "react";
import { cn } from "../lib/utils";

interface FormErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /**
   * When true, uses role="alert" + aria-live="assertive" — interrupts screen readers
   * immediately. Use for submit-blocking failures or critical errors.
   * Default (false) uses role="status" + aria-live="polite" — gentler for typed-in-progress validation.
   */
  assertive?: boolean;
}

function FormError({ assertive = false, className, children, ...props }: FormErrorProps) {
  return (
    <div
      role={assertive ? "alert" : "status"}
      aria-live={assertive ? "assertive" : "polite"}
      className={cn("mt-1 text-xs text-destructive", className)}
      {...props}
    >
      {children}
    </div>
  );
}

export { FormError };
export type { FormErrorProps };
